module.exports = __webpack_public_path__ + "img/AT.4494005e.png";